"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GovernorAlphaHarnessFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "timelock_",
                type: "address",
            },
            {
                internalType: "address",
                name: "tonic_",
                type: "address",
            },
            {
                internalType: "address",
                name: "guardian_",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "ProposalCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalExecuted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "ProposalQueued",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "support",
                type: "bool",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "votes",
                type: "uint256",
            },
        ],
        name: "VoteCast",
        type: "event",
    },
    {
        constant: true,
        inputs: [],
        name: "BALLOT_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "DOMAIN_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "__abdicate",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "__acceptAdmin",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "__executeSetTimelockPendingAdmin",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "__queueSetTimelockPendingAdmin",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "cancel",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "support",
                type: "bool",
            },
        ],
        name: "castVote",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "support",
                type: "bool",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "castVoteBySig",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [],
        payable: true,
        stateMutability: "payable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "getActions",
        outputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "voter",
                type: "address",
            },
        ],
        name: "getReceipt",
        outputs: [
            {
                components: [
                    {
                        internalType: "bool",
                        name: "hasVoted",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "support",
                        type: "bool",
                    },
                    {
                        internalType: "uint128",
                        name: "votes",
                        type: "uint128",
                    },
                ],
                internalType: "struct GovernorAlpha.Receipt",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "guardian",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "latestProposalIds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "proposalCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "proposalMaxOperations",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "proposalThreshold",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "proposals",
        outputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "forVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "againstVotes",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "canceled",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "executed",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "propose",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "queue",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "quorumVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "state",
        outputs: [
            {
                internalType: "enum GovernorAlpha.ProposalState",
                name: "",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "timelock",
        outputs: [
            {
                internalType: "contract TimelockInterface",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tonic",
        outputs: [
            {
                internalType: "contract TonicInterface",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "votingDelay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "votingPeriod",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
class GovernorAlphaHarnessFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(timelock_, tonic_, guardian_, overrides) {
        return super.deploy(timelock_, tonic_, guardian_, overrides || {});
    }
    getDeployTransaction(timelock_, tonic_, guardian_, overrides) {
        return super.getDeployTransaction(timelock_, tonic_, guardian_, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.GovernorAlphaHarnessFactory = GovernorAlphaHarnessFactory;
GovernorAlphaHarnessFactory.bytecode = _bytecode;
GovernorAlphaHarnessFactory.abi = _abi;
//# sourceMappingURL=GovernorAlphaHarnessFactory.js.map